import styled from '@emotion/styled';
import * as React from 'react';
import { memo, useState } from 'react';
import { CrossIcon } from '../../../components/Icons/CrossIcon';
import { cabin_label_shadow, darkRed, lightRed, white } from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';

const SC_CabinLeftLabel = styled.div`
    right: 0;
    z-index: 1;
    bottom: 25%;
    width: 195px;
    color: ${white};
    cursor: pointer;
    position: fixed;
    text-align: center;
    padding: 5px 25px 5px 40px;
    background-color: ${lightRed};
    box-shadow: 0 0 10px -2px ${cabin_label_shadow};
    transition: 0.5s ease;
    &.no-delay {
        right: -200px;
    }
    &:after {
        top: 0;
        left: 0;
        width: 36px;
        height: 100%;
        content: '!';
        display: block;
        font-size: 40px;
        padding-top: 2px;
        position: absolute;
        padding-right: 5px;
        background-color: ${darkRed};
        clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%, 0 0);
    }
    button {
        top: 5px;
        border: 0;
        padding: 0;
        outline: 0;
        right: 5px;
        fill: ${white};
        cursor: pointer;
        position: absolute;
        background: transparent;
    }
`;

type ICabinsLeftLabel = {
    cabinsLeft: number;
};

const goToRequestForm = () => {
    document
        .getElementById('requestFormContainer')
        .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
};

const CabinsLeftLabel = (props: ICabinsLeftLabel) => {
    const { cabinsLeft } = props;
    const [open, setIsOpen] = useState(true);
    let timeout;
    if (open) {
        timeout = setTimeout(() => {
            setIsOpen(false);
        }, 12000);
    }
    const removeLabel = (evt) => {
        evt.stopPropagation();
        clearTimeout(timeout);
        setIsOpen(false);
    };
    return (
        <SC_CabinLeftLabel
            id="cabin_left_label"
            className={!open ? 'no-delay' : ''}
            onClick={() => goToRequestForm()}
        >
            {__('urgency.sailSellingOut.{{remainingCabins}}', 'dreamlines').replace(
                '{{ remainingCabins }} ',
                `${cabinsLeft} `,
            )}
            <button onClick={(evt) => removeLabel(evt)}>
                <CrossIcon width={18} height={18} />
            </button>
        </SC_CabinLeftLabel>
    );
};

export default memo(CabinsLeftLabel);
